<template>
    <div class="personalpartbg">
        <div class="topinfo">
            <div class="topinfo_img">
                <img :src="`https://p3.udn.com.tw/wish/images/personal_pic/personal_${getsite}.png`" />
            </div>
            <div class="topinfo_info">
                <div class="topinfo_info_text">
                    {{ gettext0 }}
                </div>
                <div class="namecontainer">
                    <div class="topinfo_info_name">
                        {{ gettext1 }}
                    </div>
                </div>
            </div>
        </div>
        <toolbox
            v-for="(eachtext, index) in gettext2"
            :key="index"
            :eachtext="eachtext"
            :hint="'white'"
        >

        </toolbox>
    </div>
</template>

<script>
    import toolbox from '@/components/common/toolbox.vue'
    export default {
        data(){
            return{
                
            }
        },
        props: {
            text: { type: Array },
        },
        computed:{
            getsite(){
                return this.$store.state.currentwisher;
            },
            gettext0(){
                if(this.text!=undefined) return this.text[0];
                else return "";
            },
            gettext1(){
                if(this.text!=undefined) return this.text[1];
                else return "";
            },
            gettext2(){
                if(this.text!=undefined) return this.text.slice(2);
                else return [];
            }
        },
        mounted(){
            
        },
        components: {
            toolbox
        },
        methods:{
        },
    }
</script>

<style lang="scss" scoped>
.personalpartbg{
    position: relative;
    width: 100%;
    margin: auto;
    padding-top: 60px;
    padding-bottom: 60px;
    background-color: #FAFAFA;
    @media (min-width: 768px) {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    div + div {
        padding-top: 43px;
        @media (min-width: 768px) {
            padding-top: 40px;
        }
    }
    .topinfo{
        position: relative;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 17px;
        width: 92.27%;
        max-width: 768px;
        @media (min-width: 768px) AND (max-width: 960px) {
            max-width: 576px;
            flex-direction: row;
            margin-bottom: 40px;
        }
        @media (min-width: 960px) {
            max-width: 720px;
            flex-direction: row;
            margin-bottom: 40px;
        }
        .topinfo_img{
            position: relative;
            flex-shrink: 0;
            width: 235px;
            height: 225px;
            border-radius: 60px;
            box-shadow: 0px 0px 15px rgb(0, 0, 0, 0.2);
            @media (min-width: 320px) AND (max-width: 768px) {
                width: 270px;
                height: 250px;
                border-radius: 60px;
            }
            @media (min-width: 768px) AND (max-width: 960px) {
                width: 200px;
                height: 180px;
                border-radius: 50px;
            }
            @media (min-width: 960px) {
                width: 240px;
                height: 216px;
                border-radius: 50px;
            }
            img{
                width: 100%;
                height: 100%;
            }
        }
        .topinfo_info{
            position: relative;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            margin: -13px 0 0 0;
            @media (min-width: 768px) AND (max-width: 960px) {
                margin: 0 0 0 54px;
            }
            @media (min-width: 960px) {
                margin: 0 0 0 60px;
            }
            .topinfo_info_text{
                font-size: 27px;
                line-height: 45px;
                text-align: justify;
                font-weight: 500;
                color:#8B8B8B;
                font-family: 'Noto Serif TC';
                @media (min-width: 960px) {
                    font-size: 32px;
                    line-height: 54px;
                }
            }
            .namecontainer{
                text-align: right;
                .topinfo_info_name{
                    display: inline-block;
                    font-size: 18px;
                    line-height: 24px;
                    text-align: start;
                    font-weight: 300;
                    color:#8B8B8B;
                    font-family: 'Noto Sans TC';
                    margin-top: -30px;
                    @media (min-width: 960px) {
                        font-size: 15px;
                        line-height: 21px;
                    }
                }
            }
        }
    }
}
</style>